export const defaultSEO = {
  title: 'Rolsys Solutions | Innovación en movimiento',
  description: 'Asesoría en TI, soporte técnico en sitio (CDMX) y remoto en toda la República Mexicana.',
  image: process.env.PUBLIC_URL + '/logos/base_logo_white_background.png',
  locale: 'es_MX',
  siteName: 'Rolsys Solutions',
  type: 'website'
};

export const pageSEO = {
  home: {
    title: 'Rolsys Solutions | Innovación en movimiento',
    description: 'Asesoría en TI, soporte técnico en sitio (CDMX) y remoto en toda la República Mexicana.'
  },
  servicios: {
    title: 'Servicios de TI | Rolsys Solutions',
    description: 'Asesoría en TI, soporte en sitio en CDMX, mantenimiento y soporte remoto en México.'
  },
  nosotros: {
    title: 'Nosotros | Rolsys Solutions',
    description: 'Conoce más sobre Rolsys Solutions y nuestro enfoque en innovación tecnológica.'
  },
  contacto: {
    title: 'Contacto | Rolsys Solutions',
    description: 'Contáctanos para asesoría en TI y soporte técnico. WhatsApp: +52 55 2664 7038'
  }
};